import { EnumFilterEditor } from './enum-filter-editor'
import { TextFilterEditor } from './text-filter-editor'
import { NumberFilterEditor } from './number-filter-editor'
import { DateFilterEditor } from './date-filter-editor'
import { BooleanFilterEditor } from './boolean-filter-editor'
import type { FilterEditorType } from './filter-types'
import type { FilterOperator } from '@/types/api'

interface FilterValueEditorProps {
  editorType: FilterEditorType
  value: unknown
  operator: FilterOperator
  options?: string[]
  onValueChange: (value: unknown) => void
  onOperatorChange: (operator: FilterOperator) => void
  onRemove?: () => void
  label?: string
  fieldName?: string
}

export function FilterValueEditor({
  editorType,
  value,
  operator,
  options = [],
  onValueChange,
  onOperatorChange,
  onRemove,
  label,
  fieldName,
}: FilterValueEditorProps) {
  const renderEditor = () => {
    switch (editorType) {
      case 'enum':
        return (
          <EnumFilterEditor
            options={options}
            selectedValues={Array.isArray(value) ? value : []}
            operator={operator}
            onValuesChange={onValueChange}
            onOperatorChange={onOperatorChange}
            onRemove={onRemove}
            label={label}
            searchPlaceholder={`Search ${label?.toLowerCase() ?? 'options'}...`}
            fieldName={fieldName}
          />
        )

      case 'text':
        return (
          <TextFilterEditor
            value={typeof value === 'string' ? value : ''}
            operator={operator}
            onValueChange={onValueChange}
            onOperatorChange={onOperatorChange}
            onRemove={onRemove}
            label={label}
            placeholder={`Enter ${label?.toLowerCase() ?? 'value'}...`}
          />
        )

      case 'number':
        return (
          <NumberFilterEditor
            value={typeof value === 'number' ? value : undefined}
            operator={operator}
            onValueChange={onValueChange}
            onOperatorChange={onOperatorChange}
            onRemove={onRemove}
            label={label}
            placeholder={`Enter ${label?.toLowerCase() ?? 'number'}...`}
          />
        )

      case 'date':
        return (
          <DateFilterEditor
            value={typeof value === 'string' ? value : undefined}
            operator={operator}
            onValueChange={onValueChange}
            onOperatorChange={onOperatorChange}
            onRemove={onRemove}
            label={label}
          />
        )

      case 'boolean':
        return (
          <BooleanFilterEditor
            value={typeof value === 'boolean' ? value : undefined}
            onValueChange={onValueChange}
            onRemove={onRemove}
            label={label}
          />
        )
    }
  }

  return <>{renderEditor()}</>
}

export * from './filter-types'
export * from './operator-select'
